import { render, staticRenderFns } from "./lowRiskDialog.vue?vue&type=template&id=c4009d08"
import script from "./lowRiskDialog.vue?vue&type=script&lang=js"
export * from "./lowRiskDialog.vue?vue&type=script&lang=js"
import style0 from "./lowRiskDialog.vue?vue&type=style&index=0&id=c4009d08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports